import * as React from "react";

const SVGMinusCenter: React.FC<SvgProps> = props => (
    <svg width={14} height={14} {...props}>
        <path fill="#e00" d="M10.5 6.5v1h-7v-1z" fillRule="evenodd" />
    </svg>
);

export default SVGMinusCenter;
